// src/components/costs/SaveStatusIndicator.jsx
// Kleine Anzeige neben dem Speichern-Button: wann und wie (auto/manuell) das
// Dossier zuletzt gespeichert wurde. Wird von der Kostenschaetzung und der
// Kostenkontrolle genutzt, damit beide Toolbars identisch informieren.
import React from "react";
import {
  AUTO_SAVE_IDLE_MS,
  AUTO_SAVE_MAX_AGE_MS,
} from "../../services/costs/useEstimateEditor";

const AUTO_SAVE_HINT =
  `Auto-Save: ${Math.round(AUTO_SAVE_IDLE_MS / 1000)} Sekunden nach der letzten ` +
  `Änderung, spätestens ${Math.round(AUTO_SAVE_MAX_AGE_MS / 60000)} Minuten nach ` +
  "Beginn der Bearbeitung.";

const formatTime = (date) =>
  date.toLocaleTimeString("de-CH", { hour: "2-digit", minute: "2-digit" });

const SaveStatusIndicator = ({ isDirty, isSaving, lastSavedAt, lastSaveKind }) => {
  const kindLabel = lastSaveKind === "auto" ? "auto" : "manuell";

  return (
    <>
      {isSaving ? (
        <span className="saved-indicator">Speichert …</span>
      ) : (
        isDirty && <span className="unsaved-indicator">Nicht gespeichert</span>
      )}
      <span
        className="saved-indicator"
        title={
          lastSavedAt
            ? `${lastSavedAt.toLocaleString("de-CH")} — ${
                lastSaveKind === "auto" ? "automatisch" : "manuell"
              } gespeichert. ${AUTO_SAVE_HINT}`
            : `Noch nicht gespeichert. ${AUTO_SAVE_HINT}`
        }
      >
        {lastSavedAt
          ? `Zuletzt gespeichert: ${formatTime(lastSavedAt)} (${kindLabel})`
          : "Zuletzt gespeichert: –"}
      </span>
    </>
  );
};

export default SaveStatusIndicator;
